import { Modal } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { uploadCompanyDataDoc } from '../../../services/apis/companyManagement/CMApi';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useStartupContext } from '../../../services/contexts/assetManagement/StartupContext';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import RichTextEditorPage from '../../includes/RichTextEditorPage';

export default function CreateStartupPage() {

    const { setShowSuccess, token, logout, setLoginError, allowedFunc } = useLogin()
    const { editStartup, setEditStartup, editStartupData, setEditStartupData, createEditStartup, getAllStartupList, setStartupCompanyPitch, setStartupAboutTeam, setStartupterms, setStartupfaq, setStartupdoc } = useStartupContext()
    const { setShowRTPage, showRTPage } = useCMContext()


    const statusValues = ["DRHP Not Filed", "DRHP Filed", "DRHP Approved", "Delisted", "Listed but not traded", "IPO in Process", "Now Listed"]

    const [logoFile, setLogoFile] = useState("")
    const [name, setName] = useState(editStartupData.name)
    const [description, setDescription] = useState(editStartupData.description)
    const [key1, setKey1] = useState(editStartupData.key_value ? editStartupData.key_value.key_1 : "")
    const [key2, setKey2] = useState(editStartupData.key_value ? editStartupData.key_value.key_2 : "")
    const [value1, setValue1] = useState(editStartupData.key_value ? editStartupData.key_value.value_1 : "")
    const [value2, setValue2] = useState(editStartupData.key_value ? editStartupData.key_value.value_2 : "")
    const [isin, setISIN] = useState(editStartupData.isin)
    const [disabletrading, setDisableTrading] = useState(editStartupData.disabletrading)
    const [campaignEndDate, setCampaignEndDate] = useState(editStartupData.campaign_end_date)
    const [videoLink, setVideoLink] = useState(editStartupData.video_link)
    const [error, setError] = useState("")
    const [rtPageType, setRTPageType] = useState("")

    const [file, setFile] = useState("")
    const [fileError, setFileError] = useState("")
    const [errorDetail, setErrorDetail] = useState("")
    const [showErrorModal, setShowErrorModal] = useState(false)

    const history = useHistory()


    useEffect(() => {
        try {
            if (editStartupData) {
                setName(editStartupData.name)
                setDescription(editStartupData.description)
                setKey1(editStartupData.key_value.key_1)
                setKey2(editStartupData.key_value.key_2)
                setValue1(editStartupData.key_value.value_1)
                setValue2(editStartupData.key_value.value_2)
                setISIN(editStartupData.isin)
                setCampaignEndDate(editStartupData.campaign_end_date)
                setVideoLink(editStartupData.video_link)
                setDisableTrading(editStartupData.disabletrading.toString())
                setStartupterms(editStartupData.section_data.deal_terms)
                setStartupfaq(editStartupData.section_data.faqs)
                setStartupdoc(editStartupData.section_data.documents)
                setStartupCompanyPitch(editStartupData.section_data.company_pitch)
                setStartupAboutTeam(editStartupData.section_data.about_the_team)
                setError("")
            }
        } catch (error) {

        }
    }, [editStartupData])


    // add company function
    async function addStartup() {
        try {

            document.getElementById("StartupBtn").classList.toggle("d-none")
            document.getElementById("StartupBtnLoader").classList.toggle("d-none")

            const red = /^[0-9]\d*(\.\d{1,2})?$/;
            // .toString().match(red)
            if (editStartup && !editStartupData.id) {
                setError("Please select a valid Startup to edit.")
            } else if (!name || (name && name.length > 200)) {
                setError("Please provide a valid Startup name.")
            } else if (!description) {
                setError("Please provide a valid Description.")
            } else if (!isin || (isin && !isin.match(/^[a-zA-Z0-9]{12}$/))) {
                setError("Please provide a valid ISIN.")
            } else if (!campaignEndDate) {
                setError("Please enter a valid Campaign End Date.")
            } else if (!disabletrading || (disabletrading != null && (disabletrading != 0 && disabletrading != 1))) {
                setError("Please select valid Disable trading value.")
            } else if (!editStartup && !logoFile) {
                setError("Please select a valid logo file.")
            } else {
                let response = await createEditStartup(name, isin, campaignEndDate, videoLink, disabletrading, description, key1, value1, key2, value2, logoFile, editStartup, editStartupData.id)

                if (response && response === "success") {
                    resetValues()
                    setShowSuccess(true)
                    getAllStartupList()
                } else {
                    setError(response)
                }
            }

            document.getElementById("StartupBtn").classList.toggle("d-none")
            document.getElementById("StartupBtnLoader").classList.toggle("d-none")

        } catch (error) {
        }
    }

    // reset all values
    function resetValues() {
        try {
            setName("")
            setDescription("")
            setKey1("")
            setKey2("")
            setValue1("")
            setValue2("")
            setISIN("")
            setCampaignEndDate("")
            setVideoLink("")
            setDisableTrading("")
            setLogoFile("")
            setEditStartup(false)
            setError("")
            setStartupterms("")
            setStartupfaq("")
            setStartupdoc("")
            setStartupCompanyPitch("")
            setStartupAboutTeam("")
        } catch (error) {

        }
    }

    // get file contents through file chooser
    function uploadFile(file, type) {
        try {
            if (type === "Logo" && (file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png")) {
                setLogoFile(file)
            } else if (type !== "Logo" && (file.type === ".xls" || file.type === "xlsx" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel")) {
                setFile(file)
                setFileError("")
            } else {
                type === "Logo" ? alert("Only jpg or png files are allowed.") : alert("Only csv files are allowed.")
            }
        } catch (error) {
            console.error(error)
        }
    }

    // create role ui code
    return (
        <div id="rmCreateCompany" className="col-lg-3 col-md-4 d-md-block d-none pt-3 main-rmPanel">
            {((allowedFunc.includes(configs.functionList["startup_management:update_asset"]) && editStartup) || allowedFunc.includes(configs.functionList["startup_management:create_asset"])) ?
                <>
                    <p className="h6 text-custom-grey">{editStartup ? "Edit Startup Information" : "Add a Startup"}</p>

                    <div className="function-container-asset">
                        <form id="createRoleForm" action="" className='mr-1'>
                            <div className="form-group">
                                <label className="f-12">Startup Name</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Startup Name" value={name} required onChange={(e) => {
                                    setName(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Description</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Description" value={description} required onChange={(e) => {
                                    setDescription(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">ISIN</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="ISIN" value={isin} required onChange={(e) => {
                                    setISIN(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Campaign End Date</label>
                                <input type="date" id="roleName" className="form-control f-10" placeholder="ISIN" value={isin} required onChange={(e) => {
                                    setCampaignEndDate(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Video Link</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Video Link" value={videoLink} required onChange={(e) => {
                                    setVideoLink(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Category 1 Title</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Category 1 Title" value={key1} required onChange={(e) => {
                                    setKey1(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Category 1 Value</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Category 1 Value" value={value1} required onChange={(e) => {
                                    setValue1(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Category 2 Title</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Category 2 Title" value={key2} required onChange={(e) => {
                                    setKey2(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Category 2 Value</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Category 2 Value" value={value2} required onChange={(e) => {
                                    setValue2(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Disable Trading</label>
                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={disabletrading != null ? disabletrading : "default"} onChange={(e) => {
                                    setDisableTrading(e.target.value)
                                }}>
                                    <option className='f-12' value="default"> ---- </option>
                                    <option className='f-12' value="0"> No </option>
                                    <option className='f-12' value="1"> Yes </option>
                                </select>
                            </div>
                            <div className="form-group">
                                <a className="f-12" href='#' onClick={(e) => {
                                    e.preventDefault()
                                    setShowRTPage(true)
                                    setRTPageType("Startup Company Pitch")
                                }}>Add Company Pitch</a>
                            </div>
                            <div className="form-group">
                                <a className="f-12" href='#' onClick={(e) => {
                                    e.preventDefault()
                                    setShowRTPage(true)
                                    setRTPageType("Startup About The Team")
                                }}>Add About the Team</a>
                            </div>
                            <div className="form-group">
                                <a className="f-12" href='#' onClick={(e) => {
                                    e.preventDefault()
                                    setShowRTPage(true)
                                    setRTPageType("Startup Deal Terms")
                                }}>Add Deal Terms</a>
                            </div>
                            <div className="form-group">
                                <a className="f-12" href='#' onClick={(e) => {
                                    e.preventDefault()
                                    setShowRTPage(true)
                                    setRTPageType("Startup FAQ")
                                }}>Add FAQs</a>
                            </div>
                            <div className="form-group">
                                <label className="f-12">Logo</label>
                                <p className="pb-0 mb-0 f-12 ">
                                    <input type="file" id="logo" required hidden accept="image/jpg, image/jpeg, image/png" onChange={(e) => {
                                        uploadFile(e.target.files[0], "Logo")
                                    }} />
                                    <label htmlFor="logo" className="mb-0 p-1  curPoint btn-primary">Choose Logo File</label>
                                    <br /> File to be uploaded: <span className="text-theme">{logoFile.name}</span>
                                </p>
                            </div>
                        </form>
                    </div>
                    <div className="form-check p-0">
                        <p className="text-danger" id="createRoleError">{error}</p>
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-9 m-0 p-0'>
                            <button id="StartupBtn" className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                addStartup()
                            }}>{editStartup ? "Update Startup" : "Add Startup"}</button>
                            <div id="StartupBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                        </div>
                        <div className='col-3 m-0 p-0'>
                            <button className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                resetValues()
                            }}>Reset</button>
                        </div>
                    </div>
                    <div className='row m-0 p-0'>
                        <button className="btn btn-primary mt-3 d-md-none" onClick={(e) => {
                            e.preventDefault()
                            document.getElementById("rmCreateCompany").classList.toggle('d-none')
                            document.getElementById("companyListPage").classList.toggle('d-none')
                            history.push('/assetManagement/Startup')
                        }}>View All Startup</button>
                    </div>
                </>
                : null}
            {/* --------------------------------create compnay overview--------------------------------- */}
            {showRTPage ? <RichTextEditorPage {...{ type: rtPageType }} /> : null}
        </div>
    )
}